import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import ContactForm from './ContactForm';
import AppointmentLocationForm from './AppointmentLocationForm';
import AppointmentCalendarForm from './AppointmentCalendarForm';
import {changeAppointmentFlow} from '../actions/ContactMeActionCreators';
import { IntlProvider } from 'react-intl';
import FontAwesome from 'react-fontawesome';
import Messages from '../../common/i18n/Messages';
import MessageDefinitions from '../i18n/MessageDefinitions';
import { getLocale } from '../../common/i18n/Locale';
import Validate from 'react-form-controlled-validate';
import Screens from '../constants/Screens';
import AppointmentInformation from "./AppointmentInformation";

@connectToStores(['ContactMeStore'], (context, props) => {
  const ContactMeStore = context.getStore('ContactMeStore');

  return {
    selectedScreen: ContactMeStore.getSelectedScreen()
  };
})

class Container extends Component {
  static propTypes = {
    selectedScreen: PropTypes.string.isRequired,
    contactLead: PropTypes.object,
    contactFields: PropTypes.object,
    contactSchema: PropTypes.object,
    useAppointmentFlow: PropTypes.bool
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.backClicked = this.backClicked.bind(this);
  }

  backClicked() {
    let nextScreen = false;
    switch(this.props.selectedScreen){
      case Screens.CALENDAR:
        nextScreen = Screens.LOCATION;
        break;
      case Screens.LOCATION:
        nextScreen = Screens.CONTACT;
        break;
      case Screens.FAIL:
        nextScreen = Screens.CONTACT;
        break;
      default:
        break;
    }

    if(nextScreen){
      this.context.executeAction(changeAppointmentFlow, {nextScreen});
    }
  }

  render() {
    const {
      selectedScreen,
      contactLead,
      contactFields,
      contactSchema,
      useAppointmentFlow
    } = this.props;

    let FrameComponent = null;
    let back = undefined;
    const backButton = <button className="btn btn-link back" onClick={this.backClicked}><FontAwesome name="arrow-left" /></button>;

    switch (selectedScreen) {
      case Screens.CONTACT:
        FrameComponent = <Validate schema={contactSchema}>
          <ContactForm
            currentLead={contactLead}
            fields={contactFields}
            schema={contactSchema}
            useAppointmentFlow={useAppointmentFlow}
          />
        </Validate>;
        break;
      case Screens.LOCATION:
        FrameComponent = <AppointmentLocationForm/>;
        back = backButton;
        break;
      case Screens.CALENDAR:
        FrameComponent = <AppointmentCalendarForm/>;
        back = backButton;
        break;
      case Screens.SUCCESS:
        FrameComponent = <AppointmentInformation success/>;
        break;
      case Screens.FAIL:
        FrameComponent = <AppointmentInformation/>;
        break;
      default:
        break;
    }

    return <IntlProvider locale={getLocale()} messages={Messages.get(MessageDefinitions)}>
      <div className="form-container contactMe-flow-container">
        {back}
        {FrameComponent}
      </div>
    </IntlProvider>;
  }
}

export default Container;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/components/Container.js
 **/